import { relations } from 'drizzle-orm';
import { index, integer, pgTable, primaryKey, varchar } from 'drizzle-orm/pg-core';
import { typeIdDataType as typeId } from '../utils/typeid';
import { type Provider, account } from './account';
import { webhookEndpoint } from './webhook-endpoint';

export const webhookEndpointAccountTarget = pgTable(
  'webhook_endpoint_account_target',
  {
    endpoint_id: integer()
      .references(() => webhookEndpoint.id, { onDelete: 'cascade' })
      .notNull(),
    account_id: integer().references(() => account.id, { onDelete: 'set null' }),
    account_public_id: typeId('account', 'account_public_id').notNull(),
    account_name: varchar({ length: 255 }),
    account_provider: varchar({ length: 255 }).$type<Provider>().notNull(),
  },
  (t) => [
    primaryKey({ columns: [t.endpoint_id, t.account_public_id] }),
    index('webhook_endpoint_account_target_endpoint_id_idx').on(t.endpoint_id),
    index('webhook_endpoint_account_target_account_id_idx').on(t.account_id),
  ],
);

export const webhookEndpointAccountTargetRelations = relations(webhookEndpointAccountTarget, ({ one }) => ({
  endpoint: one(webhookEndpoint, {
    fields: [webhookEndpointAccountTarget.endpoint_id],
    references: [webhookEndpoint.id],
  }),
  account: one(account, {
    fields: [webhookEndpointAccountTarget.account_id],
    references: [account.id],
  }),
}));
